import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";
import usePageContent from "@/hooks/usePageContent";
import ScrollReveal from "@/components/ScrollReveal";

const FinalCTA = () => {
  const { t } = useTranslation();
  const { localizedPath } = useLocalizedPath();
  const { getContent } = usePageContent("home");

  return (
    <section className="section-padding bg-primary text-primary-foreground">
      <div className="container-wide text-center px-5 sm:px-6">
        <ScrollReveal>
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium mb-4 sm:mb-6">
            {getContent("home_cta_title", t("finalCta.title"))}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.1}>
          <p className="text-base sm:text-lg text-primary-foreground/70 mb-8 sm:mb-10 max-w-xl mx-auto">
            {getContent("home_cta_subtitle", t("finalCta.subtitle"))}
          </p>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <Button 
            asChild
            variant="hero" 
            size="hero" 
            className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 min-h-[52px] w-full sm:w-auto"
          >
            <Link to={localizedPath("/contact")}>
              {getContent("home_cta_button", t("finalCta.getStarted"))}
            </Link>
          </Button>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FinalCTA;
